module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/welcome-screen/welcome-screen.component.scss
// module id = ./src/app/welcome-screen/welcome-screen.component.scss
// module chunks = main